<div
	class="fixed inset-0 z-[1000] flex h-full w-full items-center justify-center overflow-auto font-sans before:fixed before:inset-0 before:h-full before:w-full before:bg-[rgba(0,0,0,0.3)]"
>
	<div class="relative flex flex-col items-center rounded-lg bg-white p-6 shadow-md">
		<app-spinner />
		@if (loadingMessage()) {
			<div class="mt-3 text-center text-base text-gray-500">
				{{ loadingMessage() }}
			</div>
		}
	</div>
</div>
